import React from 'react';
import {observer} from 'mobx-react';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    store: FrameBuilderStore;
};

export const CustomItem = observer(({store}: Props) => {
    const {frame, inchToPx} = store;
    const {customMatrix} = frame;

    return customMatrix?.flat().map((item, idx) => (
        <img
            key={idx}
            src={item.url}
            alt={item.displayType}
            style={{
                position: 'absolute',
                top: item.top !== undefined ? inchToPx(item.top) : undefined,
                bottom: item.bottom !== undefined ? inchToPx(item.bottom) : undefined,
                width: item.width === -1 ? 'auto' : inchToPx(item.width),
                height: item.height === -1 ? 'auto' : inchToPx(item.height),
            }}
        />
    ));
});
